import React, { createContext, useContext, useState, useEffect } from "react";
import { privateApi } from "../../api/axiosConfig";
import { isAuthenticated } from "../../services/auth/tokenManager";

const CartContext = createContext();

export function CartProvider({ children }) {
  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = async () => {
    if (!isAuthenticated()) return;

    try {
      const response = await privateApi.get("/api/v1/carts/list/destroy/");
      const items = response.data.results || response.data;
      
      // Sum up the quantities of all items in the cart
      const totalQuantity = items.reduce((total, item) => total + item.quantity, 0);
      setCartCount(totalQuantity);
    } catch (err) {
      console.error("Failed to fetch cart total", err);
    }
  };

  useEffect(() => {
    
    fetchCartCount();
  }, []);

  
  const updateCartCount = (amount) => {
    setCartCount((prev) => Math.max(0, prev + amount));
  };

  return (
    <CartContext.Provider value={{ cartCount, fetchCartCount, updateCartCount }}>
      {children}
    </CartContext.Provider>
  );
}

// Custom hook for easy importing
export const useCart = () => useContext(CartContext);